import { message, PageHeader, Space, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { SegmentedItem, TableItem, dineroDisabledMask, ButtonItem, TourItem } from "../../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { EditOutlined, EyeOutlined, TagOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import VerUnidadActivoFijo from "../VerUnidadActivoFijo/VerUnidadActivoFijo";
import EditarUnidadActivoFijo from "../EditarUnidadActivoFijo/EditarUnidadActivoFijo";
import AgregarUnidadActivoFijo from "../AgregarUnidadActivoFijo/AgregarUnidadActivoFijo";
import ModalEtiquetaActivoFijo from "../ModalEtiquetaActivoFijo/ModalEtiquetaActivoFijo";
import ModalEtiquetasActivosFijos from "../ModalEtiquetasActivosFijos/ModalEtiquetasActivosFijos";
import VenderActivo from "../VenderActivo/VenderActivo";
import DarDeBajaActivo from "../DarDeBajaActivo/DarDeBajaActivo";

moment.locale("es");

// Clonado del patron de Pages/Panel/Lotes/LotesProducto/LotesProducto.js —
// todas las unidades (EntradaSalida) de UN Activo especifico.
class UnidadesActivoFijo extends Component {
  refSegmentado = React.createRef();
  refTabla = React.createRef();
  state = {
    loading: false,
    openTour: false,
    todasUnidades: [],
    insumoId: this.props.location.state.id,
    proyectoId: this.props.location.state.proyectoId,
    valor: 1, // 1 Vigentes, 2 Vendidas, 3 De baja, 4 Todos
    modalVerUnidad: false,
    modalVerUnidadId: null,
    modalEditarUnidad: false,
    modalEditarUnidadId: null,
    modalAgregarUnidad: false,
    modalEtiqueta: false,
    modalEtiquetaId: null,
    modalEtiquetaFolio: null,
    modalEtiquetasTodas: false,
    modalVenderActivo: false,
    modalVenderActivoId: null,
    modalDarDeBajaActivo: false,
    modalDarDeBajaActivoId: null,
  };

  componentDidMount() {
    this.consultarUnidades(this.state.valor);
  }

  consultarUnidades(valor) {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/selectUnidadesPorActivo",
        { empresaId: this.props.empresaId, insumoId: this.state.insumoId, proyectoId: this.state.proyectoId, valor },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({ todasUnidades: res.data, loading: false });
        } else {
          this.setState({ todasUnidades: [], loading: false });
          message.info("No se encontraron unidades para este Activo.");
        }
      });
  }

  verUnidad(id) {
    this.setState({ modalVerUnidad: true, modalVerUnidadId: id });
  }
  cerrarVerUnidad() {
    this.setState({ modalVerUnidad: false, modalVerUnidadId: null });
    this.consultarUnidades(this.state.valor);
  }
  editarUnidad(id) {
    this.setState({ modalEditarUnidad: true, modalEditarUnidadId: id });
  }
  cerrarEditarUnidad() {
    this.setState({ modalEditarUnidad: false, modalEditarUnidadId: null });
    this.consultarUnidades(this.state.valor);
  }
  abrirAgregarUnidad() {
    this.setState({ modalAgregarUnidad: true });
  }
  cerrarAgregarUnidad() {
    this.setState({ modalAgregarUnidad: false });
    this.consultarUnidades(this.state.valor);
  }
  abrirEtiqueta(record) {
    this.setState({ modalEtiqueta: true, modalEtiquetaId: record._id, modalEtiquetaFolio: record.serieNumero || record.numero });
  }
  cerrarEtiqueta() {
    this.setState({ modalEtiqueta: false, modalEtiquetaId: null, modalEtiquetaFolio: null });
  }
  abrirEtiquetasTodas() {
    this.setState({ modalEtiquetasTodas: true });
  }
  cerrarEtiquetasTodas() {
    this.setState({ modalEtiquetasTodas: false });
  }
  abrirVenderActivo(id) {
    this.setState({ modalVenderActivo: true, modalVenderActivoId: id });
  }
  cerrarVenderActivo() {
    this.setState({ modalVenderActivo: false, modalVenderActivoId: null });
    this.consultarUnidades(this.state.valor);
  }
  abrirDarDeBajaActivo(id) {
    this.setState({ modalDarDeBajaActivo: true, modalDarDeBajaActivoId: id });
  }
  cerrarDarDeBajaActivo() {
    this.setState({ modalDarDeBajaActivo: false, modalDarDeBajaActivoId: null });
    this.consultarUnidades(this.state.valor);
  }

  atras() {
    this.props.history.goBack();
  }

  render() {
    const columns = [
      {
        title: "Serie / Folio",
        dataIndex: "serieNumero",
        key: "serieNumero",
        width: "12%",
      },
      {
        title: "Fecha Adquisición",
        dataIndex: "fechaAdquisicion",
        key: "fechaAdquisicion",
        render: (value) => (value ? moment(value).format("DD/MM/YYYY") : "-"),
        width: "10%",
      },
      {
        title: "Ubicación",
        dataIndex: "ubicacionFisica",
        key: "ubicacionFisica",
        width: "12%",
      },
      {
        title: "Fabricante",
        dataIndex: "fabricante",
        key: "fabricante",
        width: "10%",
        responsive: ["md"],
      },
      {
        title: "Costo",
        dataIndex: "costo",
        key: "costo",
        render: (value) => dineroDisabledMask(value),
        width: "10%",
      },
      {
        title: "Dep. Acumulada",
        dataIndex: "depreciacionAcumulada",
        key: "depreciacionAcumulada",
        render: (value) => dineroDisabledMask(value),
        width: "10%",
      },
      {
        title: "Valor en Libros",
        dataIndex: "valorEnLibros",
        key: "valorEnLibros",
        render: (value) => dineroDisabledMask(value),
        width: "10%",
      },
      {
        title: "Estado",
        key: "estado",
        align: "center",
        render: (value, record) => {
          if (!record.dadoDeBaja) return <Tag color="green" className="square-tag">Vigente</Tag>;
          if (record.tipoDisposicion === "venta") return <Tag color="blue" className="square-tag">Vendido</Tag>;
          return <Tag color="red" className="square-tag">De baja</Tag>;
        },
        width: "10%",
      },
      {
        title: "Acción",
        key: "accion",
        align: "center",
        render: (value, record, index) => (
          <Space size="small" direction="horizontal">
            <Tooltip title="Ver detalle" placement="top">
              <ButtonItem type="default" size="small" azul icon={<EyeOutlined />} key={`ver-${index}`} onClick={() => this.verUnidad(record._id)} />
            </Tooltip>
            <Tooltip title="Imprimir etiqueta" placement="top">
              <ButtonItem type="default" size="small" morado icon={<TagOutlined />} key={`etiqueta-${index}`} onClick={() => this.abrirEtiqueta(record)} />
            </Tooltip>
            {!record.dadoDeBaja && (
              <>
                <Tooltip title="Editar" placement="top">
                  <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} key={`editar-${index}`} onClick={() => this.editarUnidad(record._id)} />
                </Tooltip>
                {/* Quitado por lo pronto (pedido explícito) — dejar comentado, no borrar.
                <Tooltip title="Vender Activo" placement="top">
                  <ButtonItem type="default" size="small" verde icon={<DollarOutlined />} key={`vender-${index}`} onClick={() => this.abrirVenderActivo(record._id)} />
                </Tooltip>
                */}
                <Tooltip title="Dar de Baja" placement="top">
                  <ButtonItem type="default" size="small" rojo icon={<DeleteOutlined />} key={`baja-${index}`} onClick={() => this.abrirDarDeBajaActivo(record._id)} />
                </Tooltip>
              </>
            )}
          </Space>
        ),
        width: "16%",
      },
    ];
    return (
      <>
        <PageHeader
          onBack={() => this.atras()}
          title="Inventario de Activos - Unidades"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <Space style={{ width: "100%", minWidth: 700 }} wrap>
              {window.innerWidth > 1000 &&
                <div ref={this.refSegmentado}>
                  <SegmentedItem
                    options={[
                      { label: 'Vigentes', value: 1 },
                      { label: 'Vendidos', value: 2 },
                      { label: 'De baja', value: 3 },
                      { label: 'Todos', value: 4 },
                    ]}
                    onChange={(value) => {
                      this.consultarUnidades(value);
                      this.setState({ valor: value });
                    }}
                    value={this.state.valor}
                  />
                </div>
              }
              <ButtonItem type="default" icon={<TagOutlined />} onClick={this.abrirEtiquetasTodas.bind(this)}>
                Imprimir etiquetas
              </ButtonItem>
              {this.props.permisoAgregarUnidadActivoFijo && (
                <ButtonItem type="primary" icon={<PlusOutlined />} onClick={this.abrirAgregarUnidad.bind(this)}>
                  Agregar Unidad
                </ButtonItem>
              )}
              <ButtonItem type="default" blanco onClick={() => this.setState({ openTour: true })}>
                ¿Cómo funciona?
              </ButtonItem>
            </Space>
          }
        />
        <div ref={this.refTabla}>
          <TableItem
            size="small"
            dataSource={this.state.todasUnidades}
            columns={columns}
            pagination={false}
            loading={this.state.loading}
            onRow={(record) => ({
              onDoubleClick: () => this.verUnidad(record._id),
            })}
            noPonerClase
          />
        </div>
        <AgregarUnidadActivoFijo
          visible={this.state.modalAgregarUnidad}
          insumoId={this.state.insumoId}
          proyectoId={this.state.proyectoId}
          cerrarAgregarUnidadActivoFijo={this.cerrarAgregarUnidad.bind(this)}
        />
        <VerUnidadActivoFijo
          visible={this.state.modalVerUnidad}
          entradaSalidaId={this.state.modalVerUnidadId}
          cerrarVerUnidadActivoFijo={this.cerrarVerUnidad.bind(this)}
        />
        <EditarUnidadActivoFijo
          visible={this.state.modalEditarUnidad}
          entradaSalidaId={this.state.modalEditarUnidadId}
          cerrarEditarUnidadActivoFijo={this.cerrarEditarUnidad.bind(this)}
        />
        <ModalEtiquetaActivoFijo
          visible={this.state.modalEtiqueta}
          entradaSalidaId={this.state.modalEtiquetaId}
          folio={this.state.modalEtiquetaFolio}
          onCancel={this.cerrarEtiqueta.bind(this)}
        />
        <ModalEtiquetasActivosFijos
          visible={this.state.modalEtiquetasTodas}
          insumoId={this.state.insumoId}
          onCancel={this.cerrarEtiquetasTodas.bind(this)}
        />
        <VenderActivo
          visible={this.state.modalVenderActivo}
          entradaSalidaId={this.state.modalVenderActivoId}
          cerrarVenderActivo={this.cerrarVenderActivo.bind(this)}
        />
        <DarDeBajaActivo
          visible={this.state.modalDarDeBajaActivo}
          entradaSalidaId={this.state.modalDarDeBajaActivoId}
          cerrarDarDeBajaActivo={this.cerrarDarDeBajaActivo.bind(this)}
        />
        <TourItem
          open={this.state.openTour}
          onClose={() => this.setState({ openTour: false })}
          steps={[
            {
              title: "Unidades de este Activo",
              description: "Aquí ves cada unidad física individual de este Activo (cada una con su propio número de serie, costo y fecha de compra), y puedes darlas de alta, venderlas o darlas de baja una por una.",
              target: null,
            },
            {
              title: "Filtro por estado",
              description: "Vigentes = activas y depreciándose. Vendidos/De baja = ya salieron del inventario (quedan en el historial). Todos = ver el listado completo.",
              target: () => this.refSegmentado.current,
            },
            {
              title: "Acciones por unidad",
              description: "Ver detalle, imprimir su etiqueta, editar sus datos libres (ubicación, proveedor, etc.), venderla (captura precio de venta) o darla de baja (sin venta, ej. desecho/siniestro/donación).",
              target: () => this.refTabla.current,
            },
          ]}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarUnidadActivoFijo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a69540249a8383de2bd7878")?.activado,
  };
};

export default connect(mapStateToProps)(UnidadesActivoFijo);
